import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListInvoiceNumberCell } from './emsp-bo-invoice-list-invoice-number.cell';
import { EmspBoInvoiceListInvoiceNumberHeader } from './emsp-bo-invoice-list-invoice-number.header';

export const EmspBoInvoiceListInvoiceNumberColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['invoiceNumber']
> = {
  enableSorting: false,
  header: EmspBoInvoiceListInvoiceNumberHeader,
  cell: EmspBoInvoiceListInvoiceNumberCell,
};
